/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_Toast_Error_TitleInputs */

const es_components_file_tree_toast_error_title = /** @type {(inputs: Components_File_Tree_Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falló la ingesta`)
};

const en_components_file_tree_toast_error_title = /** @type {(inputs: Components_File_Tree_Toast_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestion failed`)
};

/**
* | output |
* | --- |
* | "Ingestion failed" |
*
* @param {Components_File_Tree_Toast_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_toast_error_title = /** @type {((inputs?: Components_File_Tree_Toast_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_Toast_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_toast_error_title(inputs)
	return en_components_file_tree_toast_error_title(inputs)
});
export { components_file_tree_toast_error_title as "components.file_tree.toast_error_title" }